<template>
  <div class="p-6 w-full h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between">
      <p class="text-3xl font-bold">Manage Board Title</p>
      <div class="flex flex-row items-center justify-between space-x-4">
        <BaseRoundedButton @click="handleCreateSlideOver">
          <p class="font-sans">Create New Title</p>
        </BaseRoundedButton>
      </div>
    </div>
    <!-- body -->
    <div>
      <table class="table-auto w-full select-none">
        <thead class="border-b-2 border-light-gray">
          <tr class="text-left text-gray text-lg">
            <th class="py-2 font-normal">Title</th>
            <th class="py-2 font-normal">created at</th>
            <th class="py-2 font-normal">updated at</th>
            <th class="py-2 font-normal text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="boardTitle in boardTitles" :key="boardTitle.id">
            <td class="text-lg pb-4">{{ boardTitle.title }}</td>
            <td class="text-lg pb-4">
              {{ moment(boardTitle.created_at).format("MMM DD, YYYY h:mm A") }}
            </td>
            <td class="text-lg pb-4">
              {{ moment(boardTitle.updated_at).format("MMM DD, YYYY h:mm A") }}
            </td>
            <td>
              <div class="flex justify-center relative">
                <Menu>
                  <MenuButton
                    ><EllipsisVerticalIcon
                      class="w-8 h-8 text-black hover:text-blue cursor-pointer"
                  /></MenuButton>
                  <MenuItems
                    class="
                      p-1
                      space-y-1
                      absolute
                      top-8
                      right-8
                      z-50
                      bg-white
                      border border-light-gray
                      shadow-md
                      rounded-lg
                      w-12/12
                    "
                  >
                    <MenuItem
                      @click="handleEditSlideOver(boardTitle)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer"
                    >
                      <div
                        class="flex flex-row items-center px-4 py-2 min-w-min"
                      >
                        <PencilIcon class="text-blue w-5 h-5 mr-4" />
                        <p class="text-blue">Edit</p>
                      </div>
                    </MenuItem>
                    <MenuItem
                      @click="handleDelTitle(boardTitle.id)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer"
                    >
                      <div
                        class="flex flex-row items-center px-4 py-2 min-w-min"
                      >
                        <TrashIcon class="text-red w-5 h-5 mr-4" />
                        <p class="text-red">Delete</p>
                      </div>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <SideBar v-show="createSlideOver" @close-modal="handleCreateSlideOver">
    <div class="w-full h-full flex flex-col content-between">
      <div>
        <h1 v-if="!updateFlag" class="text-blue text-2xl">
          Create Board Title
        </h1>
        <h1 v-else class="text-blue text-2xl">Update Board Title</h1>
      </div>
      <div class="my-4">
        <base-text-input
          v-model="title"
          name="title"
          isAutoComplete="off"
          label="Board Title"
        />
      </div>
      <!-- action button -->
      <div class="flex flex-row items-center justify-between space-x-4 mt-auto">
        <BaseRoundedButton
          @click="handleCreateSlideOver"
          class="bg-dark-gray w-2/6"
        >
          Cancel
        </BaseRoundedButton>
        <BaseRoundedButton
          v-if="!updateFlag"
          @click="handleCreate"
          class="w-4/6"
        >
          Create
        </BaseRoundedButton>
        <BaseRoundedButton v-else @click="handleSaveUpdate" class="w-4/6">
          Update
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
</template>

<script>
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
import userService from "../Services/user.service";
import moment from "moment";
import {
  EllipsisVerticalIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/vue/24/outline";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { useToast } from "vue-toastification";
import SideBar from "../components/SideBar.vue";
import BaseTextInput from "../components/BaseTextInput.vue";
export default {
  name: "ManageTitle",
  components: {
    BaseRoundedButton,
    EllipsisVerticalIcon,
    PencilIcon,
    TrashIcon,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    SideBar,
    BaseTextInput,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      createSlideOver: false,
      updateFlag: false,
      title: "",
      boardTitles: [],
      tempId: "",
    };
  },
  methods: {
    getboardTitlesList() {
      userService.getTitle().then((response) => {
        this.boardTitles = response.data.data;
      });
    },
    handleDelTitle(id) {
      this.$Progress.start();
      userService
        .delBoardTitle(id)
        .then(() => {
          this.$Progress.finish();
          this.getboardTitlesList();
          this.toast.success("Delete board title successful.");
        })
        .catch((error) => {
          this.$Progress.fail();
          console.log(error);
          this.toast.error("Error! Cannot delete board title!");
        });
    },
    handleCreateSlideOver() {
      this.createSlideOver = !this.createSlideOver;
      this.updateFlag = false;
    },
    handleCreate() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("title", this.title);

      userService
        .storeCreateTitle(formData)
        .then(() => {
          this.$Progress.finish();
          this.title = "";
          this.getboardTitlesList();
          this.createSlideOver = false;
          this.toast.success("Create baord title successful.");
        })
        .catch((error) => {
          this.$Progress.finish();
          console.log(error);
          this.toast.error("Error! Cannot create board title!");
        });
    },
    handleEditSlideOver(boardTitle) {
      this.createSlideOver = true;
      this.updateFlag = true;
      this.tempId = boardTitle.id;
      this.title = boardTitle.title;
    },
    handleSaveUpdate() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("title", this.title);

      userService
        .storeUpdateBoardTitle(this.tempId, formData)
        .then(() => {
          this.$Progress.finish();
          this.title = "";
          this.tempId = "";
          this.getboardTitlesList();
          this.createSlideOver = false;
          this.toast.success("Update baord title successful.");
        })
        .catch((error) => {
          this.$Progress.finish();
          console.log(error);
          this.toast.error("Error! Cannot update board title!");
        });
    },
  },
  created() {
    this.$Progress.start();
    this.moment = moment;
    this.getboardTitlesList();
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>
</style>